import {
  subscribeToList,
  trackProductSavedEvent,
} from '@/components/integrations/Zaius/Actions';

export const subscribeToNewsletter = async (email) => {
  return subscribeToList(email, 'newsletter');
};

export async function saveForLater(email, productContext = {}) {
  const listResult = await subscribeToList(email, 'save_for_later');

  if (listResult?.success) {
    trackProductSavedEvent(email, productContext).catch(() => {});
  }

  return listResult;
}
